module.exports = __webpack_public_path__ + "images/icons_v2/cart-baseline-1a244857.svg";